"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackButton = void 0;
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const Box_1 = __importDefault(require("@mui/material/Box"));
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const BackButton = (props) => {
    const history = (0, react_router_dom_1.useHistory)();
    const goBack = () => {
        props.updateStore('isCarouselPaused', false);
        history.push(`${props.baseUrl}/overview`);
    };
    if (history.location.pathname !== `${props.baseUrl}/overview`) {
        return (react_1.default.createElement(Box_1.default, { className: "back-button", "data-testid": "back-button", tabIndex: 0, onClick: goBack, sx: {
                cursor: 'pointer',
            } },
            react_1.default.createElement(Close_1.default, null)));
    }
    return react_1.default.createElement(react_1.default.Fragment, null);
};
exports.BackButton = BackButton;
const mapStoreToProps = store => ({
    baseUrl: store.getValue('baseUrl'),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(exports.BackButton);
